<template>
  <div>
    <v-flex v-if="addBtn == true">
      <v-btn
        v-if="flatBtn == true"
        fab
        small
        :dark="disabled == false"
        :color="customColor ? customColor : 'pink lighten-3'"
        @click="show"
        :title="textBtn"
        :disabled="disabled"
        :class="flatBtn == true ? customButtonClass : ''"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
        v-else
        slot="activator"
        :color="customColor ? customColor : 'info'"
        dark
        small
        @click="show"
        :class="customButtonClass"
        :disabled="disabled"
      >
        {{ textBtn }}
      </v-btn>
    </v-flex>
    <v-flex v-else>
      <v-text-field
        :error-messages="$errors(inner)"
        :label="labelText"
        v-model="inner.$model"
        :clearable="hasValue && !disabled"
        :readonly="readonly"
        :prepend-icon="accessTo && modelid ? 'visibility' : ''"
        @click:clear="doClear"
        @click:prepend="linkTo"
        @click="textFieldClicked"
        :disabled="false"
      >
      </v-text-field>
    </v-flex>
    <v-dialog v-model="shown" scrollable :max-width="maxWidth">
      <v-card>
        <v-card-title class="headline accent white--text">
          {{ labelText }}
        </v-card-title>

        <v-card-title>
          <slot name="search"></slot>
          <slot name="create"></slot>
        </v-card-title>

        <v-card-text>
          <datasource-table
            :datasource="datasource"
            class="mt-2"
            @item-selected="selected"
            :callRefresh="callRefresh"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="shown = false">
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import VuetifyInputExt from '@/plugins/mixins/VuetifyInputExt'
export default {
  mixins: [VuetifyInputExt],
  props: {
    datasource: {
      type: Object,
      required: true,
    },
    maxWidth: String,
    accessTo: {
      type: Boolean,
      default: false,
    },
    addBtn: {
      type: Boolean,
      default: false,
    },
    flatBtn: {
      type: Boolean,
      default: false,
    },
    textBtn: {
      type: String,
    },
    customColor: {
      type: String,
    },
    customButtonClass: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    callRefresh: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      shown: false,
      value: null,
    }
  },
  computed: {
    hasValue() {
      return this.inner.$model !== ''
    },
  },
  methods: {
    doClear() {
      this.$emit('clear')
    },
    linkTo() {
      if (this.modelid) {
        this.$emit('detailField')
      }
    },
    show() {
      this.datasource.refresh()
      this.shown = true
    },
    textFieldClicked() {
      if (!this.disabled) {
        this.$emit('click')
        this.show()
      }
    },
    selected(event) {
      this.close()
      this.$emit('item', event)
    },
    close() {
      this.shown = false
    },
  },
}
</script>

<style scoped>
.border-smooth {
  border-radius: 5px;
}
</style>
